export class PaymentmodesDto{
    paymentModeId:number;
    paymentMode:string;
    createdUser:string;
    isActive:boolean;
    
    /**
     * 
     * @param paymentModeId 
     * @param paymentMode 
     * @param createdUser
     * @param isActive
     */
    constructor(paymentModeId:number,paymentMode:string,createdUser:string,isActive:boolean){
    this.paymentModeId = paymentModeId;
    this.paymentMode = paymentMode;
    this.createdUser = createdUser;
    this.isActive = isActive
    }
}